import { takeLatest, put, all, select } from "redux-saga/effects";
import accountSlice, { LEAVE_IMPERSONATION } from "store/account/slice";
import { loginRequests } from "./login";
import { persistor } from "configurations/redux";
import { PURGE } from "store/rootReducer";
import jwtDecode from "jwt-decode";
import { getUserMapSettings } from "resources/services/userService";
import { showSnackbar } from "store/ui/snackbar/slice";
import {
  selectAccessTokenASP,
  selectExpiresAtASP,
  selectIsEcommerceSite,
} from "../selectors";
import stripeSlice from "store/stripe/customer/slice";
import { createStripeCustomer } from "resources/services/stripeService";
import UserRoles from "utilities/enumerations/UserRoles";

function* leaveImpersonation({ meta, payload }) {
  const isEcommerceSite = yield select(selectIsEcommerceSite);
  const { setStripeCustomer } = stripeSlice.actions;

  const {
    fetching,
    success,
    error,
    setAccessToken,
    setExpiresAt,
    setDocuments,
    setMyUser,
    setMyCompany,
    setPermissions,
    setMapSettings,
  } = accountSlice.actions;

  try {
    const expiresAtASP = yield select(selectExpiresAtASP);
    const accessTokenASP = yield select(selectAccessTokenASP);

    yield put(PURGE());
    yield persistor.flush();
    yield persistor.persist();

    yield put(fetching());

    const decodedToken = jwtDecode(accessTokenASP);

    yield put(setExpiresAt(expiresAtASP));
    yield put(setAccessToken(accessTokenASP));
    yield put(setPermissions(JSON.parse(decodedToken.permissions)));

    const [documents, user, company] = yield all(loginRequests);
    yield put(setDocuments(documents));
    yield put(setMyUser(user));
    yield put(setMyCompany(company));

    // NOTE: retrieve user's map settings
    const mapSettings = yield getUserMapSettings(user.uid);
    if (mapSettings) {
      yield put(setMapSettings(mapSettings));
    }

    // NOTE: only create / fetch the stripe customer IF:
    // 1. on ecommerce site
    // 2. not a legacy billing company
    // 3. not a temporary user
    if (
      isEcommerceSite &&
      !company?.isLegacyBilling &&
      user.role !== UserRoles.TemporaryUser
    ) {
      const stripeCustomer = yield createStripeCustomer({
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
      });

      yield put(setStripeCustomer(stripeCustomer));
    }

    yield put(success());

    meta?.onSuccess && meta.onSuccess();
  } catch (e) {
    yield put(error(e.data));
    yield put(showSnackbar({ message: e.data, severity: "error" }));
  }
}

export default function* watchLeavImpersonation() {
  yield takeLatest(LEAVE_IMPERSONATION.type, leaveImpersonation);
}
